import PropTypes from 'prop-types';
import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';
const IconBolt = (props) => {
  const { color, width, height } = props;
  const colorCode = colorLookup(color) ?? colorLookup('white');

  const iconWidth = width ? `${width}px` : '27px';
  const iconHeight = height ? `${height}px` : '27px';

  return (
    <SVG xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="66.2 9.7 231.6 352.6" width={iconWidth} height={iconHeight}>
      <path
        fill={colorCode}
        d="M154.5 115.6c-48.4 58.7-88.1 107.1-88.3 107.6-.2.4 20.1.9 45.1 1l45.4.3-17.8 68.5c-9.8 37.7-17.7 68.9-17.6 69.3.2.8 175.7-211.5 176.5-213.5.2-.4-20.1-.9-45.1-1l-45.4-.3L225.1 79c9.8-37.7 17.7-68.9 17.6-69.3a6779 6779 0 0 0-88.2 105.9z"
      />
    </SVG>
  );
};

IconBolt.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
export { IconBolt as default, IconBolt };
